import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar, Typography } from '@material-ui/core';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const codes = {
  informationSaved: (
    <FormattedMessage
      id="success.informationSaved"
      defaultMessage="Your information has been saved"
    />
  ),
  successfulIdVerifying: (
    <FormattedMessage
      id="success.successfulIdVerifying"
      defaultMessage="Your images were uploaded, they will be reviewed"
    />
  ),
  imageUploaded: (
    <FormattedMessage
      id="success.fileUploaded"
      defaultMessage="The file was successfully uploaded!"
    />
  ),
  reviewSaved: <FormattedMessage id="success.reviewSaved" defaultMessage="Your review was saved" />,
  reviewDeleted: (
    <FormattedMessage id="success.reviewDeleted" defaultMessage="Your review has been deleted" />
  ),
  conversationArchived: (
    <FormattedMessage
      id="success.conversationArchived"
      defaultMessage="The conversation was archived.
        You can unarchive it any time or find archived conversations using filter"
    />
  ),
  conversationUnarchived: (
    <FormattedMessage
      id="success.conversationUnarchived"
      defaultMessage="The conversation is restored from the archive"
    />
  ),
  complaintCreated: (
    <FormattedMessage
      id="success.complaintCreated"
      defaultMessage="Your complaint has been submitted"
    />
  ),
  complaintUpdated: (
    <FormattedMessage
      id="success.complaintUpdated"
      defaultMessage="Your complaint has been updated"
    />
  ),
  complaintWithdrawn: (
    <FormattedMessage
      id="success.complaintWithdrawn"
      defaultMessage="Your complaint has been withdrawn"
    />
  ),
  complaintResponded: (
    <FormattedMessage
      id="success.complaintResponded"
      defaultMessage="Your response has been submitted"
    />
  ),
  hostComplaintResponded: (
    <FormattedMessage
      id="success.hostComplaintResponded"
      defaultMessage="Your response has been submitted"
    />
  ),
};

const Success = ({ success, onClose }) => {
  if (isEmpty(success)) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open
      onClose={onClose}
    >
      <Alert onClose={onClose} severity="success">
        <Typography>{success.code ? codes[success.code] : success.message}</Typography>
      </Alert>
    </Snackbar>
  );
};

Success.propTypes = {
  success: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onClose: PropTypes.func,
};

export default Success;
